export default __webpack_public_path__ + "static/media/slider1.3beaaa7d.png";